import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateSettings } from "services";

import { GET_ADMIN_SETTINGS, UPDATE_ADMIN_SETTINGS } from "consts";

export const useUpdateAdminSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [UPDATE_ADMIN_SETTINGS],
    mutationFn: updateSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_ADMIN_SETTINGS] });
    },
  });
};
